import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function NewbornText() {

    
    return (

      <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Do your genetic variations" 
            headline_grey = "indicate a condition"
            headline_p2 = "that is important to detect early in life?"

            text1 = "This section focuses on genetic conditions that are recommended for newborn screening."
            text2 = "The panel is based on the Recommended Uniform Screening Panel (RUSP), a list curated by health experts to identify core conditions early in life when treatment or intervention can make a significant difference."
            text3 = "Our analysis checks for variants in key genes linked to these conditions to support early detection in newborns and help guide next steps of healthcare providers."

            />
    }/>
            
  )
}